// extracted by mini-css-extract-plugin
module.exports = {"patientName":"member-operations__PatientName__patientName"};